import Loading from '../../../../Dashboards/Common/Loading';
import { IndicatorCID } from './Indicator';
import { Table } from './Table';
import { Top5 } from './Top5';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const Charts = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-row-dashboards w-100">
                <IndicatorCID />
            </div>
            <div className="charts-side-by-side-dashboards">
                <Top5 />
                <Table />
            </div>
        </>
    );
};
